import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { LANDING } from "@/constants/testIds";
import { ListOrdered, ChevronDown, ChevronUp } from "lucide-react";

export default function AccessibleNeighborhoodTable({ neighborhoods = [] }) {
  const [open, setOpen] = useState(false);
  return (
    <section
      data-testid={LANDING.accessibleTable}
      aria-label="Text-based summary of neighborhoods reached"
      className="bg-white rounded-2xl border border-stone-200 p-6 sm:p-8 shadow-[0_4px_24px_rgba(0,0,0,0.04)]"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <ListOrdered size={20} className="text-[#3DA9DC]" />
          <div>
            <h3 className="font-serif text-xl font-semibold text-[#122036]">Neighborhood breakdown</h3>
            <p className="text-sm text-stone-600">Screen-reader friendly. Sorted by installed libraries.</p>
          </div>
        </div>
        <Button
          data-testid={LANDING.accessibleTableToggle}
          variant="outline"
          onClick={() => setOpen((s) => !s)}
          className="rounded-full border-stone-200"
        >
          {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          <span className="ml-1.5">{open ? "Hide" : "Show"}</span>
        </Button>
      </div>

      {open && (
        <div className="mt-6 overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="uppercase text-xs tracking-[0.14em] text-stone-500">Neighborhood</TableHead>
                <TableHead className="uppercase text-xs tracking-[0.14em] text-stone-500">Jurisdiction</TableHead>
                <TableHead className="uppercase text-xs tracking-[0.14em] text-stone-500 text-right">Installed</TableHead>
                <TableHead className="uppercase text-xs tracking-[0.14em] text-stone-500 text-right">Scheduled</TableHead>
                <TableHead className="uppercase text-xs tracking-[0.14em] text-stone-500 text-right">Pending</TableHead>
                <TableHead className="uppercase text-xs tracking-[0.14em] text-stone-500 text-right">Total</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {neighborhoods.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} className="text-center text-stone-500 py-8 text-sm">
                    No registrations yet — be the first to put a library on the map.
                  </TableCell>
                </TableRow>
              )}
              {neighborhoods.map((n) => (
                <TableRow key={`${n.jurisdiction}-${n.neighborhood}`}>
                  <TableCell className="font-medium">{n.neighborhood || "—"}</TableCell>
                  <TableCell>{n.jurisdiction}</TableCell>
                  <TableCell className="text-right tabular-nums text-[#16A34A] font-semibold">{n.active}</TableCell>
                  <TableCell className="text-right tabular-nums">{n.scheduled}</TableCell>
                  <TableCell className="text-right tabular-nums">{n.pending}</TableCell>
                  <TableCell className="text-right tabular-nums font-semibold">{n.total}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </section>
  );
}
